{
    "SignInWith_Title": "Accedi con",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Accedi utilizzando altre opzioni"
}